module.exports = __webpack_public_path__ + "img/diamond_level4.ea8d4c26.png";